import { render } from "./messageSvg.vue?vue&type=template&id=3882d7c6"
import script from "./messageSvg.vue?vue&type=script&lang=js"
export * from "./messageSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__